export function isGroupFirst(options) {
  return Boolean(options && options[0] && options[0].isGroup);
}

export function isOptionsVisible(options) {
  return options && options.length && !options.every((option) => option.isGroup);
}

export function updateIndexDown(index, options) {
  const last = options.length - 1;

  if (index < 0 || index >= last) {
    return isGroupFirst(options) ? 1 : 0;
  }

  const nextItem = options[index + 1];
  if (nextItem && nextItem.isGroup) {
    return updateIndexDown(index + 1, options);
  }

  if (index < last) {
    return index + 1;
  }

  return last;
}

export function updateIndexUp(index, options) {
  const last = options.length - 1;

  if (index <= 0 || index > last) {
    return last;
  }

  const prevItem = options[index - 1];
  if (prevItem && prevItem.isGroup) {
    return updateIndexUp(index - 1, options);
  }

  return index - 1;
}
